<template>
  <div>
    <v-form @submit.prevent="submit">
      <div class="wrapper d-flex flex-column align-center pt-10">
        <img src="@/assets/mail.svg" alt class="mt-12" />
        <h2 class="mt-6">Έχετε email</h2>
        <p
          class="text-center font-weight-light text"
          style="padding:10px 200px;"
        >Παρακαλώ ελέγξτε τα email σας και εισάγετε τον αριθμό επιβεβαίωσης που λάβατε.</p>

        <div class="password-input-container">
          <input type="tel" class="password-input" maxlength="5" v-model="verificationCode" />
          <div class="underlines-container">
            <div class="underline"></div>
            <div class="underline"></div>
            <div class="underline"></div>
            <div class="underline"></div>
            <div class="underline"></div>
          </div>
        </div>

       

        <div class="d-flex flex-column buttons">
           <v-btn
            depressed
            rounded
            color="rgb(0,170,221)"
            class="white--text text-capitalize mt-10 ml-2"
            width="200"
            type="submit"
            :loading="$store.state.loading"
            height="40"
          >
            <p class="mb-0">Συνέχεια</p>
          </v-btn>
          <v-btn text rounded width="200" class="text-capitalize mt-10" height="40" @click="resendVerification">
            <p class="mb-0">Αποστολή αριθμού ξανά</p>
          </v-btn>
         
        </div>

         <v-alert v-if="requiredError" class="mt-5" type="error">{{verificationCodeErrors[0]}}</v-alert>

         <v-alert v-if="wrongError" class="mt-5" type="error">Please try again!</v-alert>
      </div>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required,minLength } from "vuelidate/lib/validators";
import axios from 'axios'
export default {
  mixins: [validationMixin],
  created() {
    if (!!!this.$store.state.token) {
       this.$router.push("/start");
    }
  },
  methods: {
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$store.dispatch('verifyCode', {token:this.$store.state.token, verificationCode: this.verificationCode})
            .then(res => {
                console.log(res)
                this.$router.push('/welcome')
            })
            .catch(err => {
                console.log(err)
                this.wrongError = true
                setTimeout(() => {
                    this.wrongError = false
                },2000)
            })
      } else {
        this.requiredError = true;
        setTimeout(() => {
            this.requiredError = false
        }, 2000)
      }
    },
    resendVerification(){
        this.localLoading = true
        axios.get(`${process.env.VUE_APP_BASE_URL}/user/resendVerification`, {
            headers: {Authorization: 'Bearer ' + this.$store.state.token}
        })
        .then(res => {
            this.localLoading = false
        })
        .catch(err => {
            this.localLoading = false
        })
    }
  },
  data() {
    return {
      verificationCode: "",
      requiredError: false,
      wrongError: false
    };
  },
  validations: {
    verificationCode: { required, minLength: minLength(5) }
  },
  computed: {
    verificationCodeErrors() {
      const errors = [];
      if (!this.$v.verificationCode.$dirty) return errors;
      if (!this.$v.verificationCode.minLength) errors.push("Must be 5-digit");
      if (!this.$v.verificationCode.required) errors.push("Required field");
      
      return errors;
    }
  }
};
</script>

<style lang="scss" scoped>

.password-input-container {
  margin-bottom: 15px;
  transform: translateX(15px);
}
.password-input {
  border: none;
  outline: none;
  width: 275px !important;
  font-size: 30px;
  padding-left: 20px;
  letter-spacing: 30px;
}
.underlines-container {
  padding: 0 40px 0 10px;
  display: flex;
  justify-content: space-between;
  &.error {
    .underline {
      background-color: #f44336;
    }
  }
}
.underline {
  background-color: black;
  flex: 1;
  height: 4px;
  &:not(:last-of-type) {
    margin-right: 10px;
  }
  &.error {
    background-color: #f44336;
  }
}

.buttons{
  margin-top: 40px;
}

@media only screen and (max-width: 600px) {
.text{
 padding: 10px 10px !important; 
}

.buttons{
  margin-top: 80px !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
}
</style>